import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  CommonOthers,
  CommonParams,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../../types";
import {
  ChatRoom,
  CreateUserData,
  UpdateUserData,
  CreateUserPass,
  GetAllRoomsParams,
  GetUserData,
  GetUserDataParams,
  ViewUserData,
} from "../../../../types/csoManager/user";
import { handleApiError } from "../../../../utils/errorHandler";

// create
export const createUserAsync = createAsyncThunk<
  null,
  PostRequest<CreateUserData, CommonOthers>
>(
  "admin/createUser",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createUser, data, {
        headers: {},
      });

      reRender(true);
      toast("success", "User create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "User create failed");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllUserAsync = createAsyncThunk<
  GetCommonData<GetUserData>,
  Params<GetUserDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllUser", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as CommonParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllUsers, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get user fail");
    return rejectWithValue(error);
  }
});
// get all
export const getAllRooms = createAsyncThunk<
  GetCommonData<ChatRoom>,
  Params<GetAllRoomsParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllRooms", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetAllRoomsParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllRooms, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get Rooms fail");
    return rejectWithValue(error);
  }
});

// update
export const updateUserDataAsync = createAsyncThunk<
  null,
  PostRequest<UpdateUserData, GetSingleDataParams>
>(
  "admin/updateUserData",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateUser}/${id}`, data, {
        headers: {},
      });

      reRender && reRender(true);
      toast("success", "update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "update fail");
      return rejectWithValue(error);
    }
  }
);

// single
export const singUserDataAsync = createAsyncThunk<
  ViewUserData,
  Params<GetSingleDataParams>
>("admin/singUserData", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(`${BASE_API.getSingleUser}/${params?.id}`, {
      headers: {},
    });
    return data.data?.data;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Single user data get fail");
    return rejectWithValue(error);
  }
});


export const resetUserPasswordAsync = createAsyncThunk<
  null,
  PostRequest<CreateUserPass, GetSingleDataParams>
>(
  "admin/updateUserPass",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateUserPass}/${id}`, data, {
        headers: {},
      });

      reRender && reRender(true);
      toast("success", "Password reset successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "update fail");
      return rejectWithValue(error);
    }
  }
);